import { render, staticRenderFns } from "./PlanConfigurationList.vue?vue&type=template&id=0d1e25b8"
import script from "./PlanConfigurationList.vue?vue&type=script&lang=js"
export * from "./PlanConfigurationList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/group_dashboard/configured_plans.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports